module.exports = __webpack_public_path__ + "img/01.e23315cf.png";